import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useGetSolicitudGastosContingenciaProfesionalItByUser from "services/record/SolicitudGastosContingenciaProfesional/useGetSolicitudGastosContingenciaProfesionalItByUser";
import useGetInfoSolicitudGastosContingenciaProfesionalFormIt from "services/record/SolicitudGastosContingenciaProfesional/useGetInfoSolicitudGastosContingenciaProfesionalIt";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import SolicitudGastosContingenciaProfesional from "./SolicitudGastosContingenciaProfesional";


type HttpState = {
    status: number | null;
    statusText: string | null;
};

const GridSolicitudGastosContingenciaProfesional = ({ expedienteId = null, origen = null }) => {
    const { dataGetSolicitudGastosContingenciaProfesionalItByUser, getSolicitudGastosContingenciaProfesionalItByUser, successGetSolicitudGastosContingenciaProfesionalItByUser, loadingGetSolicitudGastosContingenciaProfesionalItByUser, statusGetSolicitudGastosContingenciaProfesionalItByUser } = useGetSolicitudGastosContingenciaProfesionalItByUser()
    const { getInfoSolicitudGastosContingenciaProfesionalIt, loadingGetInfoSolicitudGastosContingenciaProfesionalIt, statusGetInfoSolicitudGastosContingenciaProfesional } = useGetInfoSolicitudGastosContingenciaProfesionalFormIt()

    const [currentHttp, setCurrentHttp] = useState<HttpState>({
        status: null,
        statusText: null
    });
    const { tipogasto } = useParams<{ tipogasto: string }>();
    const location = useLocation();
    const origenValue = location?.state?.origen ?? origen ?? null;
    const expedienteIdValue = expedienteId ?? location?.state?.expedienteId ?? null;
    const [tipoGastoNumber] = useState(parseInt(tipogasto));
    enum TipoGastoEnum {
        Transporte = 1,
        Farmacia = 2,
        Ortopedia = 3,
    }
    let title;
    switch (tipoGastoNumber) {
        case TipoGastoEnum.Transporte:
            title = 'Solicitud de Abono de Gastos de Transporte';
            break;
        case TipoGastoEnum.Farmacia:
            title = 'Solicitud de Abono de Gastos de Farmacia';
            break;
        case TipoGastoEnum.Ortopedia:
            title = 'Solicitud de Abono de Gastos de Ortopedia';
            break;
        default:
            title = '';
    }
    const navigate = useNavigate();

    /// OBTENER TOKEN PARA LAS PETICIONES ///
    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    const expedienteIdByOrigen = Number(origenValue) === 1 ? (expedienteIdValue ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [arrData, setArrData] = useState(null)
    const [dataUser, setDataUser] = useState(null);
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    //Obtener Solicitudes al cargar la página
    ///////////////////////////////////////
    useEffect(() => {
        if (!userId) return;
        getSolicitudGastosContingenciaProfesionalItByUser(userId, expedienteIdByOrigen, tipoGastoNumber);
    }, [])


    /////////////////////////////////
    //Seleccionar una fila en el grid
    //////////////////////////////////
    const rowSelected = (args) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        const selectedData = args.data;
        setInfo(false)
        setDataUser(selectedData);

    };

    ////////////////////////////////////////
    //Generar formulario 1º Paso (GetInfo)
    ////////////////////////////////////////
    const handleGetInfoSolicitudGastosContingenciaProfesionalIt = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true)
        getInfoSolicitudGastosContingenciaProfesionalIt(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    }

    ///////////////////////////////////////
    //UseEffect para actualizar el grid al obtener los datos
    //////////////////////////////////////
    useEffect(() => {
        if (successGetSolicitudGastosContingenciaProfesionalItByUser) {
            setArrData(dataGetSolicitudGastosContingenciaProfesionalItByUser);
        }
    }, [dataGetSolicitudGastosContingenciaProfesionalItByUser]);



    ///////////////////////////////////////
    //UseEffect para mostrar el boton de generar formulario
    //////////////////////////////////////
    useEffect(() => {
        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [arrData]);

    /////////////////////////////////////
    //Función para mostrar el loader
    ////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetInfoSolicitudGastosContingenciaProfesionalIt ||
            (loadingGetSolicitudGastosContingenciaProfesionalItByUser && !dataUser)
        );
    };

    useEffect(() => {
     
        if (statusGetInfoSolicitudGastosContingenciaProfesional?.status) {
            setCurrentHttp({
                status: statusGetInfoSolicitudGastosContingenciaProfesional.status,
                statusText: statusGetInfoSolicitudGastosContingenciaProfesional.statusText
            });
        } else if (statusGetSolicitudGastosContingenciaProfesionalItByUser?.status) {
            setCurrentHttp({
                status: statusGetSolicitudGastosContingenciaProfesionalItByUser.status,
                statusText: statusGetSolicitudGastosContingenciaProfesionalItByUser.statusText
            });
        }
    }, [
        statusGetInfoSolicitudGastosContingenciaProfesional,
        statusGetSolicitudGastosContingenciaProfesionalItByUser
    ]);

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title} >
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>
            <div className="container">
                <ManagementFormCardList dataSource={arrData || []} onSelect={rowSelected} key={generateKey} />

                {showGenerateButton && (
                    <div className="container">
                        <div className="delta-buttons c-right">
                        <button className="btn-box btn-accent" onClick={() => handleGetInfoSolicitudGastosContingenciaProfesionalIt()}>
                            Generar Formulario
                        </button>
                        </div>
                    </div>
                )}
            </div>


            <Loader activeLoader={isLoading()} label="Cargando Formulario"></Loader>

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <SolicitudGastosContingenciaProfesional
                        key={`${info ? "create" : "edit"}-${info ? "new" : dataUser?.Id}-${tipoGastoNumber}-${formRenderKey}`}
                        prestacionId={info ? "" : dataUser.PrestacionId}
                        userId={dataUser.UsuarioId}
                        formId={info ? "" : dataUser.Id}
                        info={info}
                        tipoGasto={tipoGastoNumber}
                        onSuccess={() => getSolicitudGastosContingenciaProfesionalItByUser(userId, expedienteIdByOrigen, tipoGastoNumber)}
                    />
                </div>
            )}
            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay
                    descripcionError={
                        currentHttp.statusText || "Error al obtener los datos"
                    }
                />
            )}

        </div>
    );
};
export default GridSolicitudGastosContingenciaProfesional;
